import classnames from "classnames";
import React, { useState } from "react";
import { useLoaderData } from "react-router";
import { type FilterByTypes } from "./components/filterby";
import { getEmbedCodeText, getEmbedUrl, getRawJsonUrl } from "./embedcodes";
import { type Font, type Theme } from "./models";
import Wizard from "./wizard";

const EmbedWizardApp = () => {
  const viewModel = useLoaderData<server.viewmodel.EmbedShowsFrontModel>();

  const [displayPagination, setDisplayPagination] = React.useState<boolean>(true);
  const [displayHeader, setDisplayHeader] = React.useState<boolean>(true);
  const [locale, setLocale] = React.useState<string>(site.culture.uiLocale);
  const [font, setFont] = React.useState<Font>("Inter");
  const [perPage, setPerPage] = React.useState<string>("8");
  const [pastShowDays, setPastShowDates] = React.useState<number>(0);
  const [upcomingShowDays, setUpcomingShowDays] = React.useState<number>(365 * 2);
  const embedHeight = "800";
  const embedWidth = "100%";

  const [filterBy, setFilterBy] = React.useState<FilterByTypes>("AllArtists");
  const [selectedFilterIds, setSelectedFilterIds] = React.useState<number[]>([]);

  const [includeCancelled, setIncludeCancelled] = React.useState<boolean>(false);

  const [theme, setTheme] = useState<Theme>("normal");

  const embedUrl = getEmbedUrl(viewModel.friendlyId, displayPagination, displayHeader, locale, font, perPage, filterBy, selectedFilterIds, theme, pastShowDays, upcomingShowDays, includeCancelled);
  const jsonUrl = getRawJsonUrl(viewModel.friendlyId, locale, perPage, filterBy, selectedFilterIds, pastShowDays, upcomingShowDays, includeCancelled);
  const embedCodeText = getEmbedCodeText({ url: embedUrl, width: embedWidth, height: embedHeight });

  const previewClasses = classnames("s1_panel grow1", {
    large: embedWidth === "100%"
  });

  return <div className="flex" id="two-column-page-layout">
    <div className="margin-right-bigger smallright flex-column gap-bigger">
      <Wizard
        embedCode={embedCodeText}
        jsonUrl={jsonUrl}
        displayHeader={{ value: displayHeader, setValue: setDisplayHeader }}
        displayPagination={{ value: displayPagination, setValue: setDisplayPagination }}
        locale={{ value: locale, setValue: setLocale }}
        font={{ value: font, setValue: setFont }}
        perPage={{ value: perPage, setValue: setPerPage }}
        pastShowDays={{ value: pastShowDays, setValue: setPastShowDates }}
        upcomingShowDays={{ value: upcomingShowDays, setValue: setUpcomingShowDays }}
        filterType={{ value: filterBy, setValue: setFilterBy }}
        setFilteredByIds={setSelectedFilterIds}
        theme={{ value: theme, setValue: setTheme }}
        includeCancelled={{ value: includeCancelled, setValue: setIncludeCancelled }}
      />

      <div className="s1_panel">
        <form action="https://systemonesoftware.us13.list-manage.com/subscribe/post?u=20cb5b0b0a3bd05e1d0359ca0&amp;id=ca192042d9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" noValidate>
          <div id="mc_embed_signup_scroll" className="flex-column gap">
            <div>
              <div className="margin-bottom-small"><h3>Are you a developer?</h3></div>
              <div className="s1_gray">Be informed about important changes</div>
            </div>
            <div>
              <input type="email" name="EMAIL" className="email fluid" id="mce-EMAIL" placeholder="email address" required />

              <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
                <input type="text" name="b_20cb5b0b0a3bd05e1d0359ca0_ca192042d9" tabIndex={-1} />
              </div>
            </div>

            <div className="flex justify-end">
              <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button-new primary">Subscribe</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <embed src={embedUrl} className={previewClasses} style={theme === "dark" ? { backgroundColor: "black" } : { backgroundColor: "white" }} />
  </div>
};

export default EmbedWizardApp;